import { Money } from '@shopify/hydrogen';
import { MoneyV2 } from '@shopify/hydrogen/storefront-api-types';
import { FC } from 'react';

interface Props {
  data: Partial<MoneyV2>;
}

export const TAX_RATE = 0.1;

export const MoneyWithTax: FC<Props> = ({ data }) => (
  <Money
    data={{
      amount: (Number(data.amount) * (1 + TAX_RATE)).toString(),
      currencyCode: data.currencyCode,
    }}
  />
);
